module.exports = __webpack_public_path__ + "static/media/subscription.ddbd8aaa.svg";


//////////////////
// WEBPACK FOOTER
// ./public/img/sidebar/subscription.svg
// module id = 1034
// module chunks = 0